export const bgMixin = (active?: boolean) => `
  relative
  isolate
  before:content-['']
  before:rounded-4
  before:-z-10
  before:absolute
  before:top-1
  before:bottom-1
  before:left-0
  before:right-0
  ${
    active
      ? 'before:bg-panel-background-active'
      : 'before:hover:bg-panel-background-hover'
  }
`
